import React, { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import PurchaseItems from "./PurchaseItems";
import { Button } from "antd";
import { CreditCard, ShoppingCart, Sparkles } from "lucide-react";
import HeaderModal from "components/modal/HeaderModal";
import PurchaseDetails from "./PurchaseDetails";

const HyvidPointsPurchase = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

  return (
    <HeaderComponent
      title="Purchase Hyvid Points"
      titleClass="text-[16px] font-medium"
      description="Select a pricing tier to add credits to your company balance (AUD)"
      descriptionClass="text-sm"
    >
      <div>
        <PurchaseItems onSelectItem={setSelectedItem} />
      </div>
      <div className="flex items-center justify-end mt-4">
        <Button 
          className="btn-gradient-emerald"
          icon={<ShoppingCart className="w-4 h-4"/>}
          disabled={!selectedItem}
          onClick={openModal}
        >
          {selectedItem
            ? `Purchase ${selectedItem.points} points for ${selectedItem.price} ${selectedItem.currency}`
            : "Purchase points"}
        </Button>
      </div>
      <div className="flex flex-col gap-6 rounded-xl border mt-6 border-blue-200 bg-blue-50/50">
        <div className="pb-6 p-5">
          <div class="flex gap-3">
            <Sparkles className="h-5 w-5 text-blue-600"/>
            <div className="space-y-2">
              <p className="text-[13px] font-medium text-blue-900">About Hyvid Points</p>
              <p className="text-[12px] text-blue-700">Hyvid Points are the currency of Hyvid Rewards with a simple 1:1 conversion rate (1 AUD = 1 Point). Purchase points to award as gift credits to your team members for exceptional performance across 9 different categories. All prices are in AUD.</p>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <HeaderModal
          open={isModalOpen}
          onClose={closeModal}
          title="Confirm Purchase"
          titleClass="text-lg font-semibold"
          description="Review your purchase before confirming"
          descriptionClass="text-sm text-slate-700"
          bgcolor="white"
          width={500}
          footer={
            <div className="p-4 flex justify-end gap-2">
              <Button
                className="inline-flex items-center justify-center gap-2 rounded-xl text-sm text-gray-800 h-9 px-4"
                onClick={closeModal}
              >
                Cancel
              </Button>
              <Button
                className="btn-gradient-emerald h-9"
                icon={<CreditCard className="w-4 h-4"/>}
              >
                Confirm Purchase
              </Button>
            </div>
          }
        >
          <PurchaseDetails selectedItem={selectedItem}/>
        </HeaderModal>
        )}
    </HeaderComponent>
  );
};

export default HyvidPointsPurchase;
